import { render, staticRenderFns } from "./DataInputKeybind.vue?vue&type=template&id=37ec244b&"
import script from "./DataInputKeybind.vue?vue&type=script&lang=js&"
export * from "./DataInputKeybind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports